import React from 'react';
import { Translate } from 'react-jhipster'; // eslint-disable-line

import MenuItem from 'app/shared/layout/menus/menu-item'; // eslint-disable-line

const EntitiesMenu = () => {
  return (
    <>
      {/* prettier-ignore */}
      <MenuItem icon="asterisk" to="/accommodation-type">
        <Translate contentKey="global.menu.entities.accommodationType" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/car-or-van-availability">
        <Translate contentKey="global.menu.entities.carOrVanAvailability" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/general-health">
        <Translate contentKey="global.menu.entities.generalHealth" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/age-by-single-year-of-age">
        <Translate contentKey="global.menu.entities.ageBySingleYearOfAge" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/central-heating">
        <Translate contentKey="global.menu.entities.centralHeating" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/disability">
        <Translate contentKey="global.menu.entities.disability" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/economic-activity-status">
        <Translate contentKey="global.menu.entities.economicActivityStatus" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/ethnic-group">
        <Translate contentKey="global.menu.entities.ethnicGroup" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/household-composition">
        <Translate contentKey="global.menu.entities.householdComposition" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/household-size">
        <Translate contentKey="global.menu.entities.householdSize" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/industry">
        <Translate contentKey="global.menu.entities.industry" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/method-of-travel-to-work">
        <Translate contentKey="global.menu.entities.methodOfTravelToWork" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/occupation">
        <Translate contentKey="global.menu.entities.occupation" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/religion">
        <Translate contentKey="global.menu.entities.religion" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/tenure">
        <Translate contentKey="global.menu.entities.tenure" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/number-of-rooms">
        <Translate contentKey="global.menu.entities.numberOfRooms" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/number-of-bedrooms">
        <Translate contentKey="global.menu.entities.numberOfBedrooms" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/sex">
        <Translate contentKey="global.menu.entities.sex" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/country-of-birth">
        <Translate contentKey="global.menu.entities.countryOfBirth" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/highest-level-of-qualification">
        <Translate contentKey="global.menu.entities.highestLevelOfQualification" />
      </MenuItem>
      <MenuItem icon="asterisk" to="/provision-of-unpaid-care">
        <Translate contentKey="global.menu.entities.provisionOfUnpaidCare" />
      </MenuItem>
      {/* jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here */}
    </>
  );
};

export default EntitiesMenu;
